export default "__VITE_ASSET__C03LXoEK__"